import React from "react";
import "./styles.css";

import MECLogo from "../../assets/MEC Logo without text.svg";
import SawtiLogo from "../../assets/logoWithText.svg";
import Facebook from "../../assets/facebook.svg";
import Instagram from "../../assets/instagram.svg";
import Youtube from "../../assets/youtube.svg";
import Whatsapp from "../../assets/whatsapp.svg";
import Mail from "../../assets/mail.svg";

function Footer() {


    return (
        <>
            <div id="footer">
                <div id="inner-footer">

                    <div id="footer-logos">
                        <a target="_blank" rel="noopener noreferrer" href="https://middleeastcenter.org/"><img className="mec-logo-img" alt="MEC Logo" src={MECLogo} /></a>
                        <img className="sawti-logo-img" alt="MEC Logo" src={SawtiLogo} />
                    </div>

                    <div className="footer-divider" />

                    <div id="footer-social-media">
                        <p>Follow us on:</p>
                        <div id="footer-social-media-icons">
                            <a href="https://www.facebook.com/meceventsmiddleeastcenter" target="_blank" rel="noopener noreferrer"><img className="social-media" alt="Facebook" src={Facebook} /></a>
                            <a href="https://www.instagram.com/mec.events.middleeastcenter/" target="_blank" rel="noopener noreferrer"><img className="social-media" alt="Instagram" src={Instagram} /></a>
                            <a href="https://www.youtube.com/@mecworship" target="_blank" rel="noopener noreferrer"><img className="social-media" alt="Youtube" src={Youtube} /></a>
                        </div>
                    </div>

                    <div className="footer-divider" />

                    <div id="footer-contact-us">
                        <p style={{ textAlign: "center" }}>Contact us at:</p>
                        <div id="contact-us-info">
                            <div style={{ display: "flex", cursor: "pointer" }} onClick={() => { window.location.replace("mailto::worship@middleeastcenter.org") }} >
                                <a href="mailto:worship@middleeastcenter.org" target="_blank" rel="noopener noreferrer"><img style={{ marginRight: "10px" }} className="social-media" alt="Mail" src={Mail} /></a>
                                <p className="contact-us-info-details">worship@middleeastcenter.org</p>
                            </div>
                            <div style={{ display: "flex", cursor: "pointer" }} onClick={() => { window.location.replace("tel:+96181947903") }} >
                                <a href="tel:+96181947903" target="_blank" rel="noopener noreferrer"><img style={{ marginRight: "10px" }} className="social-media" alt="Whatsapp" src={Whatsapp} /></a>
                                <p className="contact-us-info-details"> +961 81 947 903</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Footer;
